export default __webpack_public_path__ + "static/media/MyBooks.718f0339.svg";